// Small helpers of a system's detail page (e.g. mraaliERP): which currency to show a visitor, and how to write a price.
// Kept free of React so they can be tested.

const EURO_COUNTRIES = ["DE", "FR", "ES", "IT", "NL", "BE", "AT", "PT", "IE", "FI", "GR", "LU", "SK", "SI", "EE", "LV", "LT", "MT", "CY", "HR"];

// "en-PK" -> "PK", "zh-Hant-TW" -> "TW", "en" -> "" (a language alone says nothing about the country).
export function regionOf(locale) {
  const parts = String(locale || "").split(/[-_]/).slice(1);
  const region = parts.find((p) => /^[A-Za-z]{2}$/.test(p));
  return region ? region.toUpperCase() : "";
}

// The currency for a visitor: first the country their IP address is in (when the server could tell), then the country of
// their first browser language that we have prices for; the euro for the euro countries. Otherwise the one marked
// DEFAULT, otherwise the first.
export function pickCurrency(currencies, locales = [], country = "") {
  const list = currencies || [];
  const has = (code) => list.find((c) => c.country_code === code);
  const forCountry = (code) => (code ? has(code) || (EURO_COUNTRIES.includes(code) ? has("EU") : null) : null);
  const byIp = forCountry(String(country || "").toUpperCase());
  if (byIp) return byIp;
  for (const locale of locales) {
    const found = forCountry(regionOf(locale));
    if (found) return found;
  }
  return has("DEFAULT") || list[0] || null;
}

// The price of a plan in a country, falling back to the DEFAULT price; null when there is none.
export function priceFor(plan, countryCode) {
  const prices = (plan && plan.prices) || {};
  if (prices[countryCode] != null) return prices[countryCode];
  return prices.DEFAULT != null ? prices.DEFAULT : null;
}

export function formatPrice(symbol, amount) {
  if (amount == null || amount === "" || Number.isNaN(Number(amount))) return "";
  return `${symbol || ""}${Number(amount).toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
}

// What is stored with a quote request so the team knows what the visitor saw: "₨42,000 (PKR)".
export function quotedPrice(currency, amount) {
  const text = formatPrice(currency && currency.symbol, amount);
  return text && currency ? `${text} (${currency.currency_code})` : "";
}

// "{email}" in the admin-written success text becomes the visitor's address.
export function fillEmail(text, email) {
  return String(text || "").replace(/\{email\}/g, email || "");
}
